// @flow

export const ServiceActionTypes = {
  FILTER: 'filter',
  READ: 'read',
  WRITE: 'write',
  SEARCH: 'search',
  SEARCH_OR_WRITE: 'search_or_write',
};
